<template>
    <div :class="icon" class="avatar"></div>
</template>

<script>
export default {
    props: {
        icon: {
            type: String,
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@dsee/mixins.scss';

.avatar {
    @include icon(30px, 30px);
    cursor: default;
    
    &.DOCUMENT_ADDED {
        background-image: url('./icons/document.svg');
    }

    &.STATUS_CHANGED {
        background-image: url('./icons/status.svg');
    }

    &.TOP_VIEWED {
        background-image: url('./icons/top.svg');
    }

    &.PILOT_ADDED,
    &.TAG_CHANGED {
        background-image: url('./icons/pilot.svg');
    }

    &.HIGH_RATED {
        background-image: url('./icons/rated.svg');
    }

    &.DIGEST {
        background-image: url('./icons/digest.svg');
    }

    &.CREATED {
        background-image: url('./icons/created.svg');
    }

    &.OFFICE_CHANGED {
        background-image: url('./icons/status.svg');
    }
}
</style>
